import React from 'react';
import { GitBranchIcon } from 'lucide-react';
export function RulesWorkflowManager({
  locale
}) {
  return <div className="space-y-6" data-id="element-10510">
      <div className="mb-8" data-id="element-10511">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-10512">Rules & Workflows</h2>
        <p className="mt-1 text-sm text-gray-500" data-id="element-10513">
          Configure and manage business rules and approval workflows
        </p>
      </div>
      <div className="bg-white shadow overflow-hidden sm:rounded-md p-6" data-id="element-10514">
        <div className="flex items-center justify-center h-40 flex-col space-y-4 text-gray-500" data-id="element-10515">
          <GitBranchIcon className="h-12 w-12" data-id="element-10516" />
          <p data-id="element-10517">Rules and Workflow management interface is under development.</p>
          <div className="flex space-x-4" data-id="element-10518">
            <a href="#" onClick={e => {
            e.preventDefault();
            window.history.pushState({}, '', '?view=rules');
          }} className="text-indigo-600 hover:text-indigo-800" data-id="element-10519">
              Go to Rules Manager
            </a>
            <a href="#" onClick={e => {
            e.preventDefault();
            window.history.pushState({}, '', '?view=workflows');
          }} className="text-indigo-600 hover:text-indigo-800" data-id="element-10520">
              Go to Workflow Manager
            </a>
          </div>
        </div>
      </div>
    </div>;
}